document.querySelector('.header__topbar-navtoggler').addEventListener('click', () => {
  document.body.classList.toggle('activenav');
})

// Trick VH for mobile Devices
let vh = window.innerHeight * 0.01;

let setVHSize = () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

document.addEventListener('DOMContentLoaded', setVHSize);
window.addEventListener('resize', setVHSize);

// Back-To-Top-Toggle

document.querySelector('.backtotoptoggle').addEventListener('click', () => {
  window.scrollTo(0,0);
})

// Font-Size

let increaseFontSize = () => {
  document.documentElement.style.setProperty('--basefontsize',  parseInt(getComputedStyle(document.body).getPropertyValue('--basefontsize').replace('px', '')) + 1 + 'px');
}
let decreaseFontSize = () => {
  document.documentElement.style.setProperty('--basefontsize',  parseInt(getComputedStyle(document.body).getPropertyValue('--basefontsize').replace('px', '')) - 1 + 'px');
}
let resetFontSize = () => {
  if (window.innerWidth >= 992) {
    document.documentElement.style.setProperty('--basefontsize', '18px');
    return;
  }
  document.documentElement.style.setProperty('--basefontsize', '16px');
}

// Set Fontsize once on pageload

document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth >= 992) {
    document.documentElement.style.setProperty('--basefontsize', '18px');
    return;
  }
  document.documentElement.style.setProperty('--basefontsize', '16px');
})

// Update on Click
document.querySelector('.header__topbar-fontsizesetting-increase').addEventListener('click', increaseFontSize);
document.querySelector('.header__menubar-nav-fontsizesetting-increase').addEventListener('click', increaseFontSize);
document.querySelector('.header__topbar-fontsizesetting-decrease').addEventListener('click', decreaseFontSize);
document.querySelector('.header__menubar-nav-fontsizesetting-decrease').addEventListener('click', decreaseFontSize);
document.querySelector('.header__topbar-fontsizesetting-reset').addEventListener('click', resetFontSize);
document.querySelector('.header__menubar-nav-fontsizesetting-reset').addEventListener('click', resetFontSize);

// Contact-Toggle

document.querySelector('.contacttoggle').addEventListener('click', () => {
  document.body.classList.add('activecontact');
})
document.querySelector('.contactsidebar__closer').addEventListener('click', () => {
  document.body.classList.remove('activecontact');
})

// Offcanvas Functionality
for (let parentMenuItem of document.querySelectorAll('.header__menubar-nav ul li.parent')) {
  parentMenuItem.querySelector('a, span').addEventListener('click', (e) => {
    if (window.innerWidth < 1280) {
      e.preventDefault();
      parentMenuItem.classList.toggle('expanded');
    }
  })
}

// Searchtoggle

document.querySelector('.header__menubar-searchtoggle').addEventListener('click', () => {
  document.body.classList.toggle('activesearch');
})

// Header-Animation

window.addEventListener('scroll', () => {
  if(window.innerWidth >= 1280) {
    if(window.scrollY > 50) {
      document.body.classList.add('body--scrolled')
    } else {
      document.body.classList.remove('body--scrolled')
    }
  }
})